/**
 * Normalizes searchSlots (and similar) API payloads into a theatre array.
 */
export function normalizeTheatersList(payload) {
  if (payload == null) return [];
  if (Array.isArray(payload)) return payload;

  const tryKeys = [
    "details",
    "data",
    "result",
    "theatres",
    "theaterList",
    "theatreList",
    "list",
    "items",
    "records",
  ];
  for (const k of tryKeys) {
    if (Array.isArray(payload[k])) return payload[k];
  }

  if (typeof payload === "object") {
    const vals = Object.values(payload).filter(
      (v) =>
        v &&
        typeof v === "object" &&
        !Array.isArray(v) &&
        (v.name != null || v.theatreName != null || v.timeslots != null)
    );
    if (vals.length > 0) return vals;
  }

  return [];
}
